import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'notif-info',
  templateUrl: './notif-info.component.html',
  styleUrls: ['./notif-info.component.css']
})
export class NotifInfoComponent implements OnInit {
  @Input() msg : string;
  @Input() closable : string;
  @Input() mini ? = false;
  @Input() bold ? = false;
  constructor() { }

  ngOnInit() {
  }

}
